<div class="container-fluid py-3" [formGroup]="formGroup">
    @if (notificationsFilteredAndSorted$ | async; as notifications) {
        <div class="p-1 d-flex justify-content-end" style="gap: 0.25rem">
            <i
                popoverClass="custom-popover"
                ngbPopover="{{
                    ('monitoring_notification_daterange_information_popover' | translate).replace(
                        '{0}',
                        startDate$ | async | appdate
                    )
                }}"
                class="bi bi-info-circle"
                style="cursor: pointer"></i>

            <app-input-date-range-picker [required]="true" [formControlName]="'dateRange'">
            </app-input-date-range-picker>
        </div>
        @if (notifications.loading) {
            <app-load />
        } @else {
            @if (notifications.value.length >= 5000) {
                <div class="alert alert-warning">
                    {{
                        'notification-history_the_number_of_notifications_exceeds_limit'
                            | translate: 'online' : 'monitoringAlarms'
                    }}
                </div>
            }
            <div class="table-responsive w-100">
                <table class="table table-striped table-sm table-hover">
                    <thead>
                        <tr>
                            <th class="d-flex">
                                <i
                                    popoverClass="custom-popover"
                                    ngbPopover="{{
                                        'monitoring_notification_type_information_popover'
                                            | translate
                                    }}"
                                    class="bi bi-info-circle me-1"
                                    style="cursor: pointer"></i>
                                <div
                                    app-sortable-table-header
                                    [column]="'combinedType'"
                                    (sort)="onSort($event)"
                                    [label]="'monitoring_notification_type' | translate"></div>
                            </th>
                            <th
                                app-sortable-table-header
                                [column]="'name'"
                                (sort)="onSort($event)"
                                [label]="'common_name' | translate"></th>
                            <th
                                app-sortable-table-header
                                [column]="'notificationSent'"
                                (sort)="onSort($event)"
                                [label]="'monitoring_notification_sent' | translate"></th>
                            <th
                                app-sortable-table-header
                                [column]="'recipientEmails'"
                                (sort)="onSort($event)"
                                [label]="'monitoring_recipient_e-mail' | translate"></th>
                            <th class="last-col"></th>
                        </tr>
                        <tr [formGroup]="formGroupFilter">
                            <th class="align-top">
                                <app-input-dropdown-checkboxes
                                    [formControl]="formGroupFilter.controls.notificationTypes" />
                            </th>

                            <th class="align-top">
                                <app-input-text-group
                                    [formControl]="
                                        formGroupFilter.controls.name
                                    "></app-input-text-group>
                            </th>
                            <th class="align-top">
                                <app-input-date-group
                                    [formControl]="
                                        formGroupFilter.controls.notificationSent
                                    "></app-input-date-group>
                            </th>
                            <th class="align-top">
                                <app-input-text-group
                                    [formControl]="
                                        formGroupFilter.controls.recipientEmails
                                    "></app-input-text-group>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="text-nowrap">
                        @for (
                            notification of notifications.value
                                | slice: (page.value - 1) * pageSize : page.value * pageSize;
                            track $index
                        ) {
                            <tr
                                (click)="openNotificationModal(notification.emailLogId)"
                                style="cursor: pointer">
                                <td>
                                    @if (notification.translationKey != null) {
                                        {{
                                            notification.translationKey
                                                | translate: 'online' : notification.module
                                        }}
                                    }
                                </td>
                                <td>
                                    {{ notification.name }}
                                </td>
                                <td>
                                    {{ notification.notificationSent | appdatetime }}
                                </td>
                                <td>
                                    {{ notification.recipientEmails.substring(0, 50) }}
                                    @if (notification.recipientEmails.length > 50) {
                                        &hellip;
                                    }
                                </td>
                            </tr>
                        } @empty {
                            <tr>
                                <td colspan="5" class="text-center">
                                    {{ 'table_noResults' | translate: 'online' : 'common' }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div class="text-center">
                <app-pagination
                    [collectionSize]="notifications.value.length"
                    [page]="page.value"
                    (pageChange)="setPage($event)"
                    [(pageSize)]="pageSize"></app-pagination>
            </div>
        }
    } @else {
        <app-load />
    }
</div>
